import { render } from "./CostOfCongestion.vue?vue&type=template&id=bba406e6&scoped=true"
import script from "./CostOfCongestion.vue?vue&type=script&lang=js"
export * from "./CostOfCongestion.vue?vue&type=script&lang=js"

import "./CostOfCongestion.vue?vue&type=style&index=0&id=bba406e6&scoped=true&lang=scss"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba406e6"]])

export default __exports__